var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-model-params"},_vm._l((_vm.paramsList),function(item){return _c('div',{key:item[0],staticClass:"info-item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item[0]))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item[1]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }